<template>
  <main class="main-container">
    <go-back
        v-if="canBackSearch"
        text="Назад к поиску"
        @click="$router.push('/search')"
        mini
        :style="backSearchStyle"
    />

    <recipe-menu v-if="isMenuTabActive" class="mb-3"/>

    <transition name="fade" mode="out-in">
      <router-view />
    </transition>

    <transition name="fade" mode="out-in">
      <buy-subscription v-if="buySubscribeActive" @close="buySubscribeActive = false" :menuId="menu_id"/>
    </transition>

    <transition name="fade" mode="out-in">
      <buy-special v-if="buySpecialActive" @close="buySpecialActive = false" :setId="set_id" :locked="locked"/>
    </transition>

    <transition name="fade" mode="out-in">
      <div class="k-global-notify" v-if="notify.active" :class="notify.type">
        <p>{{ notify.text }}</p>
        <img
          src="../assets/Group302.svg"
          alt="avatar"
          @click="notify.active = false"
        />
      </div>
    </transition>

  </main>
</template>

<script>
  import RecipeMenu from '../components/TheRecipeMenu';
  import BuySubscription from './BuySubscription';
  import BuySpecial from './BuySubscriptionTabs/BuySpecialPromocode';
  import { buySpecialMenu } from '../api/SubscribeApi';

  import { mapActions, mapGetters } from 'vuex';
  import GoBack from "@/components/TheGoBack";

  export default {
    name: "index",
    components: {
      RecipeMenu,
      BuySubscription,
      BuySpecial,
      GoBack,
    },
    data: () => ({
      buySubscribeActive: false,
      buySpecialActive: false,

      specialIsBoughting: false,
      menu_id: '',
      set_id: '',
      locked: false,

      notify: {
        active: false,
        text: '',
        type: 'red',
      },

      timeout: null,

      canBackSearch: false,
    }),
    watch: {
      '$route.query.back_search': {
        handler: function(v) {
          if (v === 't') {
            this.canBackSearch = true;
          }
        },
        deep: true,
        immediate: true
      }
    },
    created() {
      this.$root.$on('buy-subscribe', (menu_id) => {
        this.menu_id = menu_id;
        this.buySubscribeActive = true;
      })
      this.$root.$on('buy-subscription-special', async (set_id, locked, free) => {
        this.set_id = set_id;
        await this.$nextTick();

        if (free) {
          await buySpecialMenu({
            recipe_set_id: set_id,
          });
          await this.loadUser();

          return;
        }

        this.locked = locked;
        this.buySpecialActive = true;
      })
      this.$root.$on('notify', (notifyData) => {
        if (this.timeout) clearTimeout(this.timeout)

        this.notify = {
          active: true,
          ...notifyData,
        }

        this.timeout = setTimeout(() => {
          this.notify.active = false;
        }, 2500);
      })
    },
    methods: {
      ...mapActions([
        'loadUser'
      ])
    },
    computed: {
      ...mapGetters([
        'getUserFamily',
        'getUserSets',
      ]),
        getMainProfile() {
          return this.getUserFamily.find(el => el.is_main === 't');
        },
        isMenuTabActive() {
          return this.$route.matched.some(el => el.name === 'Index') && !this.$route.matched.some(el => el.name === 'UserSubscribes');
        },
      backSearchStyle() {
        const style = {
          margin: '10px 10px 0 10px',
          width: 'calc(100% - 20px)',
        }
        if (this.$mq !== 'xs' && this.$mq !== 'sm') {
          style.marginBottom = '-30px';
        }
        return style;
      }
    },
  }
</script>

<style lang="scss" scoped>
.k-global-notify {
  position: fixed;
  bottom: -80px;
  right: 20px;
  border-radius: 4px;
  transition: bottom 1s linear;
  padding: 16px;
  width: auto;
  min-height: 80px;
  min-width: 300px;
  max-width: 300px;
  display: flex;
  justify-content: space-between;

  &.green { background: #9DC43B; bottom: 20px; z-index: 1; }
  &.red { background: #C23440; bottom: 20px; z-index: 1; }

  p {
    align-self: center;
    color: white;
    margin: 0 10px;
  }

  img {
    align-self: flex-start;
    margin-left: 10px;
  }

}

.main-container {}
</style>
